import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Badge from '@material-ui/core/Badge';

import { userActions } from '../../_actions';
import { connect } from 'react-redux';
import { compose } from "recompose";

const styles = theme => ({
    Content: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    button: {
        margin: theme.spacing.unit,
    },
    tabPaper: {
        flexGrow: 1,
        borderRadius: '5px',
        boxShadow: '0px 3px 5px 0px rgba(0, 0, 0, 0.2)',
        marginBottom: '20px'
    },
    padding: {
        padding: `0 ${theme.spacing.unit * 2}px`,
    }
});

class OptionsBar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: 3,
        };
    }

    componentDidMount() {
        this.props.dispatch(userActions.getAll());
    }

    handleTabsChange = (event, value) => {
        this.setState({ value });
        this.props.handleTabsChange(value);
    };

    render() {
        const { classes, user, tasksissues } = this.props;

        return (
            <Paper square className={classes.tabPaper}>
                <Tabs
                    value={this.state.value}
                    onChange={this.handleTabsChange}
                    fullWidth
                    indicatorColor="secondary"
                    textColor="secondary"
                >
                    <Tab label={user.departmentId + " - Team"} />
                    <Tab label="My Tasks" />
                    <Tab label="My Issues" />
                    <Tab label={<Badge badgeContent={myTasksCount(tasksissues.items, user.id)} className={classes.padding} color="secondary">My Pending & In-Progress</Badge>} />
                    <Tab label="I've Assigned to Others" />
                </Tabs>
            </Paper>
        );
    }
}

function myTasksCount(data, UserId) {
    var count = 0;
    data && data.map(element => {
        if (element.AssignedToId === UserId || element.OwnerId === UserId) {
            if (element.Status !== 3 && element.Status !== 4) {
                count++;
            }
        }
        return null
    })

    return count
}

function mapStateToProps(state) {
    const { user } = state.authentication;
    const { users, projects, tasksissues } = state;

    return {
        user,
        users,
        projects,
        tasksissues
    };
}

OptionsBar.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

export default compose(connect(mapStateToProps), withStyles(styles, { withTheme: true }))(OptionsBar);


// WEBPACK FOOTER //
// ./src/components/TasksIssues/OptionsBar.js